const isDateObjectCode = `import { isDateObject } from 'cristatus';

const isDateObject = isDateObject(new Date()); //true
`;

export default isDateObjectCode;
